export default __webpack_public_path__ + "static/Robinsons Hotels Text (White)-79fe69f55dfc9bc0cfb8ff29c425ab1a.png";